const prefix = 'content-users'

export enum ContentUsersQueryKeys {
  ContentUserQualifications = `${prefix}/ContentUserQualifications`,
}
